// the base url is handled in the api calls from the env variable API_URL
export const getBaseApiUrl = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev') {
        return 'http://localhost:3002';
    } else if (environment == 'staging') {
        return 'https://enabled-dev.azurewebsites.net';
    } else if (environment == 'production') {
        return 'https://services.cephable.com';
    } else if (environment == 'staging-local') {
        return 'https://enabled-dev.azurewebsites.net';
    }

    return 'https://services.cephable.com';
};

export const getAuthRedirectUri = (): string => {
    if ((window as any).ADMIN_ENVIRONMENT) {
        return getAdminAuthRedirectUri();
    }
    if (!(window as any).WEB_ENVIRONMENT || (window as any).DESKTOP_ENVIRONMENT) {
        return 'enabledplay://authcallback';
    }
    if ((window as any).ENABLED_ENVIRONMENT == 'dev') {
        return 'http://localhost:3000/authcallback';
    } else if ((window as any).ENABLED_ENVIRONMENT == 'staging') {
        return 'https://enableddevportal.z13.web.core.windows.net/authcallback';
    } else if ((window as any).ENABLED_ENVIRONMENT == 'production') {
        return 'https://portal.cephable.com/authcallback';
    } else if ((window as any).ENABLED_ENVIRONMENT == 'staging-local') {
        // for parity to desktop app development
        return 'https://dev-app.cephable.com/authcallback';
    }
    return 'https://portal.cephable.com/authcallback';
};

const getAdminAuthRedirectUri = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev') {
        return 'http://localhost:3004/';
    } else if (environment == 'staging') {
        return 'https://enableddevportal.z13.web.core.windows.net/';
    } else if (environment == 'production') {
        return 'https://portal.cephable.com/';
    } else if (environment == 'staging-local') {
        // for parity to desktop app development
        return 'http://localhost:3004/';
    }
    return 'https://portal.cephable.com/';
};

export const getAnalyticsApiUrl = (): string => {
    const environment = process.env.ENABLED_ENVIRONMENT || 'production';
    if (environment == 'dev') {
        return 'http://localhost:3003';
    } else if (environment == 'staging' || environment == 'staging-local') {
        return 'https://enabled-dev-analytics.azurewebsites.net';
    } else if (environment == 'production') {
        return 'https://analytics.cephable.com';
    }

    return 'https://analytics.cephable.com';
};
